// @flow

import { type UserInputValidationError, VALID } from '@tectonics/prs/validation';

export function validateUruguayanCity(cityValue: string): ?UserInputValidationError {
  return cityValue && cityValue.length > 0 ? VALID : { id: 'empty' };
}
